import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import styled, { css } from 'styled-components';
import PriceWithSymbol from '../../../../../../utils/currency/PriceWithSymbol';
import { PATH_KEY_TO_POSITION } from '../../constants';
import { displayChoiceLimit, displayPriceSubUnit } from '../../utils';
import Panel from '../shared/Panel';

const LEVEL = PATH_KEY_TO_POSITION['variantIdx'];

const GridWithStyles = withStyles({
  container: {
    paddingBottom: '9px',
  },
})(Grid);

const OptionsContainer = styled.div`
  padding: 0 55px 4px 55px;
  font-size: 13px;

  ${props =>
    props.level &&
    css`
      padding-left: ${40 + 40 * props.level}px;
    `}

  @media (max-width: 900px) {
    ${props =>
      props.level &&
      css`
        padding-left: 85px;
      `}
  }
`;

const PriceContainer = styled.div`
  padding-right: 9px;

  @media (max-width: 900px) {
    margin-right: 10px;
    padding-right: 0;
  }
`;

const ChoiceLimitContainer = styled.div`
  margin-right: 9px;
  width: 97px;
  text-align: right;

  @media (max-width: 900px) {
    width: 70px;
    margin-right: 10px;
  }
`;

function optionStyleOverrides(option) {
  if (option.status !== 'live') {
    return { color: '#969696' };
  }

  return {};
}

function VariantItem(props) {
  const { variant, parent, isExpanded, setIsExpanded, isAnyChildItemExpanded } =
    props;
  const variantWithStatus = { ...variant, status: parent.status };

  return (
    <Panel
      key={`variant-item-panel-${variant.id}`}
      item={variantWithStatus}
      level={LEVEL}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
      choiceLimit={
        variant.variantType === 'multiple'
          ? displayChoiceLimit(variant.choice_limit)
          : null
      }
      hideBorders={true}
      hideHeaderMargin={true}
      isAnyChildItemExpanded={isAnyChildItemExpanded}
    >
      <OptionsContainer level={LEVEL}>
        {(variant.children || []).map((option, idx) => (
          <GridWithStyles
            key={`${option.name}-${idx}`}
            container
            style={optionStyleOverrides(option)}
          >
            <Grid item xs={6} style={{ paddingLeft: '11px' }}>
              {option.name}
            </Grid>
            <Grid item container justify="flex-end" md={3} xs={4}>
              <PriceContainer>
                + <PriceWithSymbol price={displayPriceSubUnit(option.price)} />
              </PriceContainer>
              <ChoiceLimitContainer>
                {variant.variantType === 'multiple'
                  ? displayChoiceLimit(option.choice_limit)
                  : null}
              </ChoiceLimitContainer>
            </Grid>
          </GridWithStyles>
        ))}
      </OptionsContainer>
    </Panel>
  );
}

export default VariantItem;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/VariantList/variant-item.jsx